import styled from 'styled-components';
import { flexRowCSS } from '../styled';

export const TopPanelWrapper = styled.div`
  padding: 2.5px 0;
  position: relative;
  width: 100%;
`;

export const HeaderWrapper = styled.div`
  background-color: #fff;
  width: 100%;
  ${flexRowCSS}
  padding: 3px;
`;

export const SummaryWrapper = styled.div`
  margin-bottom: 2.5px;
  background-color: #fff;
  width: 100%;
  ${flexRowCSS}
  padding: 3px;
`;

export const TabRow = styled.div`
  position: relative;
  width: 100%;
  height: 30px;
  background-color: white;
`;

export const TabWrapper = styled.div`
  position: absolute;
  width: 100%;
`;
